import React, { Component } from 'react'
import Chart from './Graph'
import Container from '@material-ui/core/Container';

export default class GraphTest extends Component {
    render() {
        return (
            <div>
                <Container>
                    <Chart />
                </Container>
            </div>
        )
    }
}
